(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var chip = e.target.closest('[data-catalog-filter]');
  if (!chip) return;
  var root = chip.closest('[data-catalog]');
  if (!root) return;
  var filter = chip.getAttribute('data-catalog-filter');

  root.querySelectorAll('[data-catalog-filter]').forEach(function (c) {
    var active = c === chip;
    c.classList.toggle('is-active', active);
    c.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  var shown = 0;
  root.querySelectorAll('[data-catalog-card]').forEach(function (card) {
    var match = filter === 'all' || card.getAttribute('data-type') === filter;
    card.classList.toggle('is-hidden', !match);
    if (match) shown++;
  });

  var count = root.querySelector('[data-catalog-count]');
  if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opening-soon"]) return;
  try {
    
(function () {
  var root = document.querySelector('.os-page');
  if (!root) return;

  // "Have the password?" toggles the storefront password form
  var pw = document.getElementById('os-pw');
  var toggle = root.querySelector('.os-pw-toggle');
  if (toggle && pw) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      pw.hidden = !pw.hidden;
      if (!pw.hidden) {
        var inp = pw.querySelector('input[name="password"]');
        if (inp) inp.focus();
      }
    });
    // Wrong password submitted — reopen the form so the error is visible
    if (pw.querySelector('.os-pw-error')) pw.hidden = false;
  }

  // Seamless ticker: the -50% keyframe loop is only gapless while each half
  // of the track is at least viewport-wide, so clone the phrase group until
  // it is, and scale the duration so the scroll speed stays constant.
  var tickerTrack = root.querySelector('.os-ticker-track');
  if (tickerTrack) {
    var tickerGroup = tickerTrack.querySelector('.os-ticker-group');
    var TICKER_SPEED = 48; // px per second — matches the original 22s pass
    var tickerCopies = 0;
    var buildTicker = function () {
      var groupWidth = tickerGroup.getBoundingClientRect().width;
      if (!groupWidth) return;
      var needed = Math.max(1, Math.ceil(tickerTrack.parentElement.clientWidth / groupWidth));
      if (needed !== tickerCopies) {
        tickerCopies = needed;
        while (tickerTrack.children.length > 1) tickerTrack.removeChild(tickerTrack.lastChild);
        for (var i = 1; i < needed * 2; i++) {
          var clone = tickerGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          tickerTrack.appendChild(clone);
        }
      }
      tickerTrack.style.animationDuration = (needed * groupWidth / TICKER_SPEED) + 's';
    };
    buildTicker();
    window.addEventListener('resize', buildTicker);
    // Fredoka loading changes the group's width — remeasure once fonts settle
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildTicker);
  }

  // Reveal-on-scroll, ported from the mockup
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var ease = 'cubic-bezier(.22,1,.36,1)';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.style.opacity = el.dataset.rvOpacity || '';
      el.style.transform = el.dataset.rvTransform || '';
      io.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  var vh = window.innerHeight;
  root.querySelectorAll('[data-os-reveal]').forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < vh * 0.92) return; // already in view — never hide it
    var t = el.style.transform || '';
    el.dataset.rvTransform = t;
    el.dataset.rvOpacity = el.style.opacity || '';
    var d = parseFloat(el.getAttribute('data-os-reveal-delay') || '0') || 0;
    el.style.transition = 'opacity 0.9s ' + ease + ' ' + d + 's, transform 0.9s ' + ease + ' ' + d + 's';
    el.style.opacity = '0';
    el.style.transform = (t ? t + ' ' : '') + 'translateY(36px)';
    io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist"]) return;
  try {
    
(function () {
  var box = document.querySelector('.wl-count');
  if (!box) return;
  var span = box.querySelector('.wl-count-inline');
  if (!span) return;

  var base = parseInt(box.getAttribute('data-base'), 10);
  if (isNaN(base)) base = parseInt(span.textContent.replace(/[^0-9]/g, ''), 10) || 0;

  var KEY = 'wl_joined';

  // If the success message is showing, this visitor just signed up — remember it.
  if (document.querySelector('.wl-success')) {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  var joined = false;
  try { joined = localStorage.getItem(KEY) === '1'; } catch (e) {}

  span.textContent = (joined ? base + 1 : base).toLocaleString();
})();

  } catch(e) { console.error(e); }
})();
})();
